// See mapping: https://github.bumble.dev/server/bumble/blob/master/_packages/Location/Country.php
export enum Country {
  UNKNOWN = -1,
  AUSTRALIA = 1,
  AUSTRIA = 2,
  AZERBAIJAN = 3,
  ANGUILLA = 4,
  ARGENTINA = 5,
  ARMENIA = 6,
  BELARUS = 7,
  BELIZE = 8,
  BELGIUM = 9,
  BERMUDA = 10,
  BULGARIA = 11,
  BRAZIL = 12,
  UK = 13,
  HUNGARY = 14,
  VIETNAM = 15,
  HAITI = 16,
  GUADELOUPE = 17,
  GERMANY = 18,
  NETHERLANDS = 19,
  GREECE = 20,
  GEORGIA = 21,
  DENMARK = 22,
  EGYPT = 23,
  ISRAEL = 24,
  INDIA = 25,
  IRAN = 26,
  IRELAND = 27,
  SPAIN = 28,
  ITALY = 29,
  KAZAKHSTAN = 30,
  CAMEROON = 31,
  CANADA = 32,
  CYPRUS = 33,
  KYRGYZSTAN = 34,
  CHINA = 35,
  COSTA_RICA = 36,
  KUWAIT = 37,
  LATVIA = 38,
  LIBYA = 39,
  LITHUANIA = 40,
  LUXEMBOURG = 41,
  MEXICO = 42,
  MOLDOVA = 43,
  MONACO = 44,
  NEW_ZEALAND = 45,
  NORWAY = 46,
  POLAND = 47,
  PORTUGAL = 48,
  REUNION = 49,
  RUSSIA = 50,
  EL_SALVADOR = 51,
  SLOVAKIA = 52,
  SLOVENIA = 53,
  SURINAME = 54,
  USA = 55,
  TAJIKISTAN = 56,
  TURKMENISTAN = 57,
  TURKS_CAICOS = 58,
  TURKEY = 59,
  UGANDA = 60,
  UZBEKISTAN = 61,
  UKRAINE = 62,
  FINLAND = 63,
  FRANCE = 64,
  CZECH_REPUBLIC = 65,
  SWITZERLAND = 66,
  SWEDEN = 67,
  ESTONIA = 68,
  SOUTH_KOREA = 69,
  JAPAN = 70,
  CROATIA = 71,
  ROMANIA = 72,
  HONG_KONG = 73,
  INDONESIA = 74,
  JORDAN = 75,
  MALAYSIA = 76,
  SINGAPORE = 77,
  TAIWAN = 78,
  BOSNIA_AND_HERZEGOVINA = 79,
  BAHAMAS = 80,
  CHILE = 81,
  COLOMBIA = 82,
  ICELAND = 83,
  NORTH_KOREA = 84,
  MACEDONIA = 85,
  MALTA = 86,
  PAKISTAN = 87,
  PAPUA_NEW_GUINEA = 88,
  PERU = 89,
  PHILIPPINES = 90,
  SAUDI_ARABIA = 91,
  THAILAND = 92,
  UAE = 93,
  GREENLAND = 94,
  VENEZUELA = 95,
  ZIMBABWE = 96,
  KENYA = 97,
  ALGERIA = 98,
  LEBANON = 99,
  BOTSWANA = 100,
  TANZANIA = 101,
  NAMIBIA = 102,
  ECUADOR = 103,
  MOROCCO = 104,
  GHANA = 105,
  SYRIA = 106,
  NEPAL = 107,
  MAURITANIA = 108,
  SEYCHELLES = 109,
  PARAGUAY = 110,
  URUGUAY = 111,
  CONGO_BRAZZAVILLE = 112,
  CUBA = 113,
  ALBANIA = 114,
  NIGERIA = 115,
  ZAMBIA = 116,
  MOZAMBIQUE = 117,
  NORTHERN_MARIANA_ISLANDS = 118,
  ANGOLA = 119,
  SRI_LANKA = 120,
  ETHIOPIA = 121,
  TUNISIA = 122,
  BOLIVIA = 123,
  PANAMA = 124,
  MALAWI = 125,
  LIECHTENSTEIN = 126,
  BAHRAIN = 127,
  BARBADOS = 128,
  CENTRAL_AFRICAN_REPUBLIC = 129,
  CHAD = 130,
  ISLE_OF_MAN = 131,
  JAMAICA = 132,
  MALI = 133,
  MADAGASCAR = 134,
  SENEGAL = 135,
  TOGO = 136,
  HONDURAS = 137,
  DOMINICAN_REPUBLIC = 138,
  MONGOLIA = 139,
  IRAQ = 140,
  SOUTH_AFRICA = 141,
  ARUBA = 142,
  GIBRALTAR = 143,
  AFGHANISTAN = 144,
  ANDORRA = 145,
  MARSHALL_ISLANDS = 146,
  ANTIGUA_AND_BARBUDA = 147,
  BANGLADESH = 149,
  BENIN = 151,
  BHUTAN = 152,
  BRITISH_INDIAN_OCEAN_TERRITORY = 153,
  BRITISH_VIRGIN_ISLANDS = 154,
  BRUNEI = 155,
  BURKINA_FASO = 156,
  BURUNDI = 157,
  CAMBODIA = 158,
  CAPE_VERDE = 159,
  CAYMAN_ISLANDS = 160,
  CHRISTMAS_ISLAND = 161,
  COCOS_KEELING_ISLANDS = 163,
  COMOROS = 164,
  CONGO = 165,
  COOK_ISLANDS = 166,
  COTE_DIVOIRE = 168,
  DJIBOUTI = 169,
  DOMINICA = 170,
  EAST_TIMOR = 171,
  EQUATORIAL_GUINEA = 172,
  ERITREA = 173,
  FAROE_ISLANDS = 175,
  FIJI = 176,
  FRENCH_GUIANA = 177,
  FRENCH_POLYNESIA = 178,
  GABON = 180,
  GAMBIA = 181,
  USA_VIRGIN_ISLANDS = 182,
  GRENADA = 184,
  GUATEMALA = 185,
  GUERNSEY = 186,
  GUINEA = 187,
  GUINEA_BISSAU = 188,
  GUYANA = 189,
  HOLY_SEE_VATICAN_CITY = 191,
  JERSEY = 193,
  KIRIBATI = 195,
  LAOS = 196,
  LESOTHO = 197,
  LIBERIA = 198,
  GUAM = 199,
  MALDIVES = 200,
  MARTINIQUE = 201,
  MAURITIUS = 202,
  MAYOTTE = 203,
  MONTSERRAT = 204,
  MYANMAR = 205,
  NAURU = 206,
  CURACAO = 207,
  NEW_CALEDONIA = 208,
  NICARAGUA = 209,
  NIGER = 210,
  NIUE = 211,
  NORFOLK_ISLAND = 212,
  OMAN = 213,
}

export const EUCountries = [
  Country.AUSTRIA,
  Country.BELGIUM,
  Country.BULGARIA,
  Country.CROATIA,
  Country.CYPRUS,
  Country.CZECH_REPUBLIC,
  Country.DENMARK,
  Country.ESTONIA,
  Country.FINLAND,
  Country.FRANCE,
  Country.GERMANY,
  Country.GREECE,
  Country.HUNGARY,
  Country.IRELAND,
  Country.ITALY,
  Country.LATVIA,
  Country.LITHUANIA,
  Country.LUXEMBOURG,
  Country.MALTA,
  Country.NETHERLANDS,
  Country.POLAND,
  Country.PORTUGAL,
  Country.ROMANIA,
  Country.SLOVAKIA,
  Country.SLOVENIA,
  Country.SPAIN,
  Country.SWEDEN,
];

export const isEuCountry = (country: Country) => {
  return EUCountries.includes(country);
};
